import { render, staticRenderFns } from "./CardStatus.vue?vue&type=template&id=3129b2d3&scoped=true&"
import script from "./CardStatus.vue?vue&type=script&lang=js&"
export * from "./CardStatus.vue?vue&type=script&lang=js&"
import style0 from "./CardStatus.vue?vue&type=style&index=0&id=3129b2d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3129b2d3",
  null
  
)

export default component.exports